import { render, staticRenderFns } from "./device-on-off-install1.vue?vue&type=template&id=1e87e61f&scoped=true&"
import script from "./device-on-off-install1.js?vue&type=script&lang=js&"
export * from "./device-on-off-install1.js?vue&type=script&lang=js&"
import style0 from "./device-on-off-install1.css?vue&type=style&index=0&id=1e87e61f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87e61f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VRadio,VRadioGroup})
